import FingerprintJS from '@fingerprintjs/fingerprintjs'
import getCurrencies from 'api/currencies'
import demoAuthRegister from 'api/demoAuth'
import loadGeoInfo from 'api/loadGeoInfo'
import cn from 'classnames'
import Cookies from 'js-cookie'
import { FC, ReactNode, useEffect, useRef, useState } from 'react'
import useAntifraudSDK from 'utils/hooks/useAntifraudSDK'
import useIsQVariant from 'utils/hooks/useIsQVariant'
import setTokensAndRedirect from 'utils/setTokensAndRedirect'

import { useRouter } from 'next/router'

import Menu from 'components/Menu/Menu'
import Footer from 'sections/Footer/Footer'

import styles from './MainLayout.module.scss'

interface IProps {
  authLayout?: boolean
  children?: ReactNode
  referrer?: string
  contentClassName?: string
}
const MainLayout: FC<IProps> = ({ children, authLayout, referrer, contentClassName }) => {
  const [isDeepLink, setIsDeepLink] = useState('')
  const autoRegisterAttemptedRef = useRef(false)
  const { initAntifraudSession } = useAntifraudSDK()

  const isQ = useIsQVariant()

  const location = useRouter()
  useEffect(() => {
    const params = new URLSearchParams(location.query.search as string)
    const clickId = params.get('click_id')
    const offer = params.get('offer')
    const partnerId = params.get('partner_id')
    const ref = params.get('ref')
    const subId = params.get('sub_id10')
    const subId8 = params.get('sub_id8')

    if (subId8) {
      Cookies.set('sub_id8', subId8, { expires: 45 })
    }

    if (subId) {
      Cookies.set('sub_id10', subId, { expires: 45 })
      const subId10 = Cookies.get('sub_id10')
      setIsDeepLink(subId10 || '')
    }

    if (clickId) {
      const id: string = Array.isArray(clickId) ? clickId.join('') : clickId
      Cookies.set('click_id', id, { expires: 45 })
    }
    if (partnerId) {
      const pid: string = Array.isArray(partnerId) ? partnerId.join('') : partnerId
      Cookies.set('partner_id', pid, { expires: 45 })
    }

    if (offer) {
      const pid: string = Array.isArray(offer) ? offer.join('') : offer
      Cookies.set('offer', pid, { expires: 45 })
    }

    if (ref) {
      const rf: string = Array.isArray(ref) ? ref.join('') : ref
      localStorage.setItem('_ref', rf)
    }
  }, [location.pathname, location.query.search, setIsDeepLink])

  useEffect(() => {
    const shouldAutoRegister =
      isDeepLink === 'demo' &&
      isQ &&
      !localStorage.getItem('accessToken') &&
      !localStorage.getItem('refreshToken') &&
      !autoRegisterAttemptedRef.current

    if (!shouldAutoRegister) return

    autoRegisterAttemptedRef.current = true

    const getReferralCookies = () => {
      const offer = Cookies.get('offer')
      const clickId = Cookies.get('click_id')
      const partnerId = Cookies.get('partner_id')
      const refs: Record<string, any> = {}
      if (clickId) refs.clickId = clickId
      if (offer) refs.offer = offer
      if (partnerId) refs.partnerId = partnerId
      return refs
    }

    const run = async () => {
      try {
        const [fp, sessionId, currenciesRes] = await Promise.all([
          FingerprintJS.load(),
          initAntifraudSession(`quick-${Date.now()}`, 'quick'),
          getCurrencies(),
        ])
        const fpResponse = await fp.get()
        const items: any[] = Object.values(currenciesRes?.data?.payload?.items || {})
        const available = items.filter((item: any) => item.isCanRegistered)
        const findByCode = (code: string) =>
          available.find((opt: any) => opt.code?.toUpperCase() === code.toUpperCase())
        const usd = findByCode('USD')
        let preferredCurrencyId = usd?.id || available[0]?.id

        const { hostname } = window.location
        let registrationSourceId: number | string = getReferralCookies()?.registrationSourceId
        if (hostname.includes('binany24.com')) {
          registrationSourceId = 14
        } else if (hostname.includes('binany.com')) {
          registrationSourceId = 13
        } else if (hostname.includes('1binany.com')) {
          registrationSourceId = 15
        } else if (hostname.includes('2binany.com')) {
          registrationSourceId = 16
        } else if (hostname.includes('3binany.com')) {
          registrationSourceId = 17
        } else if (hostname.includes('4binany.com')) {
          registrationSourceId = 18
        } else if (hostname.includes('5binany.com')) {
          registrationSourceId = 19
        } else if (hostname.includes('binany.in')) {
          registrationSourceId = 20
        } else if (hostname.includes('binanyinkenya.com')) {
          registrationSourceId = 21
        } else if (hostname.includes('binanybd.com')) {
          registrationSourceId = 22
        } else if (hostname.includes('binany.ke')) {
          registrationSourceId = 23
        } else if (hostname.includes('binany1.com')) {
          registrationSourceId = 24
        }

        const geoRes = await loadGeoInfo()
        const geo = geoRes?.data?.payload?.code
        const found = available.find((option: any) =>
          option.countries?.toUpperCase()?.split(',')?.includes(String(geo).toUpperCase()),
        )
        if (found) preferredCurrencyId = found.id

        const res = await demoAuthRegister({
          visitorId: fpResponse.visitorId,
          preferredCurrency: preferredCurrencyId as number,
          ...getReferralCookies(),
          registrationSourceId,
          sessionId: sessionId || undefined,
        })

        const { accessToken, refreshToken } = res?.data?.payload || {}
        if (accessToken && refreshToken) {
          Cookies.set('justRegisteredOnPromo', 'true')
          localStorage.setItem('justRegisteredOnPromo', 'true')
          await setTokensAndRedirect(accessToken, refreshToken)
        }
      } catch (e) {
        console.error(e)
      }
    }

    run()
  }, [isDeepLink])

  return (
    <>
      <Menu referrer={referrer} />
      <div className={cn(styles.Content, contentClassName)}>{children}</div>
      <Footer referrer={referrer} authLayout={authLayout} />
    </>
  )
}

export default MainLayout
